import React, { useEffect, useState } from 'react';
import { InterruptionTypeAPI } from '../../../../services/external/APIs';
import { BaseSelector } from '../../../../models/baseSelector';
import AsyncSelect from 'react-select/async';
import { InterruptionAllowedCover } from '../../../../models/interruptions/interruptionAllowedCover';

interface Props {
    name: string;
    disable?: boolean;
    onChange: (name: string, value: string | null | number | undefined) => void;
    value: string | undefined | number;
}

export const InterruptionAllowedCoverSelector = ({
    name,
    onChange,
    disable = false,
    value,
}: Props) => {
    const [dataList, setDataList] = useState<BaseSelector[]>([]);
    const [isLoadingData, setIsLoadingData] = useState(true);

    useEffect(() => {
        InterruptionTypeAPI.getInterruptionsAllowedToCoverType()
            .then((res) => {
                const convertedResponse = res.map(
                    (item: InterruptionAllowedCover) => {
                        return {
                            label: item.name,
                            value: item.id,
                        };
                    }
                );
                setDataList(convertedResponse);
            })
            .finally(() => {
                setIsLoadingData(false);
            });
    }, []);

    const filterName = (inputValue: string) => {
        return dataList.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const loadOptions = (
        inputValue: string,
        callback: (options: BaseSelector[]) => void
    ) => {
        setTimeout(() => {
            callback(filterName(inputValue));
        }, 1000);
    };
    
    return (
        <AsyncSelect
            isLoading={isLoadingData}
            onChange={(e) => {
                onChange(name, e?.value);
            }}
            cacheOptions
            loadOptions={loadOptions}
            defaultOptions={dataList}
            name='destiny-selector'
            placeholder={`Seleccione...`}
            className='flex-1'
            isDisabled={disable}
            isClearable
            value={
                dataList.find((a) => a.value === value) ?? {
                    label: `Seleccione...`,
                    value: 0,
                }
            }
        />
    );
};
